import styled, { css } from 'styled-components'

// Components
import { Icon } from 'components/icon'
import { Button } from 'components/button'
import { Skeleton } from 'components/skeleton'
import { TitledCard } from 'components/titledCard'
import { Select } from 'components/navbar/components/chainSelect'


export const BuyCard = styled(TitledCard)<{
    buyMargin: boolean;
}>`
  display: flex;
  flex-direction: column;
  
  .buytitle {
     margin-bottom: ${props => (props.buyMargin ? "10px" : "var(--size-large)")};
     z-index: 3;
     display: inline-flex;
     width: fit-content;
  }
`

export const BuyButton = styled(Button)`
  /*margin-top: var(--size-medium);*/
  margin-top: 14px;
  align-self: end;
  width: 100%;
`

export const BuyForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const TotalDiscount = styled.div`
  margin-top: 6px;
  font-size: var(--font-extra-small);
  font-weight: var(--font-weight-medium);
  position: absolute;
`

export const ButtonContainer = styled.div``

interface ExchangeRatePrams {
  disabled?: boolean
}

export const HalfFont = styled.span`
  font-size: 18px;
  margin-right: 2px;
`

export const UnderPairRow = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .switchOn {
    margin-top: var(--size-small)
  }
  @media (max-width: 285px) {
    flex-wrap: wrap-reverse;

    & > * {
      margin-bottom: var(--size-medium);
      width: 100%;

      button {
        width: 40%;
      }
    }
  }
`

export const ButtonRow = styled.div`
  display: flex;

  ${Button} {
    white-space: nowrap;
    font-size: var(--font-extra-small);
    font-weight: var(--font-weight-semi-bold);

    &:first-child {
      margin-right: var(--size-small);
    }
    &:last-child {
      margin-left: var(--size-small);
    }
  }
`

export const ExchangeRate = styled.div<ExchangeRatePrams>`
  font-size: var(--font-extra-small);
  font-weight: var(--font-weight-bold);
  color: inherit;
  display: flex;
  align-items: center;

  ${Skeleton} {
    width: 12px;
    margin: 0px var(--size-small);
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: var(--disabled);
    `}
`

export const RateIcon = styled(Icon).attrs(() => ({
  icon: 'sync',
}))`
  margin-right: var(--size-small);
  color: var(--disabled);
`
export const DiscountWrapp = styled.div`
    position: relative;
    height: fit-content;
`

export const BuySelectContainer = styled.div`
    position: relative;
    height: fit-content;
`

export const BuySelect = styled(Select)``